(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-vmax-search-filter-root]');

  roots.forEach(function (root) {
    var toggle = root.querySelector('[data-vmax-search-filter-toggle]');
    var panel = root.querySelector('[data-vmax-search-filter-panel]');
    var closeButtons = root.querySelectorAll('[data-vmax-search-filter-close]');
    var mobileQuery = window.matchMedia('(max-width: 991px)');
    var previousFocus = null;

    if (!toggle || !panel) return;

    root.classList.add('vmax-search-filters--ready');

    function isOpen() {
      return root.classList.contains('is-open');
    }

    function syncAccessibility() {
      if (mobileQuery.matches) {
        panel.setAttribute('aria-hidden', isOpen() ? 'false' : 'true');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
      } else {
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    }

    function openPanel() {
      previousFocus = document.activeElement;
      root.classList.add('is-open');
      document.body.classList.add('vmax-search-filters-drawer-open');
      toggle.setAttribute('aria-expanded', 'true');
      syncAccessibility();

      var firstFocusable = panel.querySelector('button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }

    function closePanel(restoreFocus) {
      root.classList.remove('is-open');
      document.body.classList.remove('vmax-search-filters-drawer-open');
      toggle.setAttribute('aria-expanded', 'false');
      syncAccessibility();

      if (restoreFocus && previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    function trapFocus(event) {
      if (!mobileQuery.matches || !isOpen() || event.key !== 'Tab') return;

      var focusable = panel.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    toggle.addEventListener('click', openPanel);

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closePanel(true);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        closePanel(true);
        return;
      }

      trapFocus(event);
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', function () {
        if (!mobileQuery.matches) closePanel(false);
        syncAccessibility();
      });
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(function () {
        if (!mobileQuery.matches) closePanel(false);
        syncAccessibility();
      });
    }

    syncAccessibility();
  });

  document.querySelectorAll('[data-vmax-search-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  });
})();
